// ? setup beforeEach nav guard
import type { NavigationGuardWithThis } from 'vue-router';
import { authenticationGuard } from '@/plugins/auth';

export const globalBeforeEachGuard: NavigationGuardWithThis<undefined> = authenticationGuard;
